import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactECharts from 'echarts-for-react';
import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import ReactDOMServer from 'react-dom/server';
import { getTop10NameWordsByYearInfo } from '../slices/storeSlice';
import globalValues from "../store/globalValues";

//region style
const Subtitle = styled.p`
    text-align: center;
    font-weight: bold;
    color: #064645;

    ${(props) => {

      if (props.theme.isMobile || props.theme.isTablet) {
        return css`
          margin-top:45px;
          margin-bottom: 16px;
          font-size: 40px;
          `;
      }
      else {
        return css`
        margin-top: 150px;
        margin-bottom: 45px;
        font-size: 50px;
          `;
      }
    }}

`;

const HiddenDiv = styled.div`
position: absolute;
top: -20px;
background-color: black;
color: white;
height: 118px;
width: 170px;
opacity: 0.8;
`;

const HiddenDivName = styled.div`
  display: flex;
  line-height: normal;
  font-size: 18px;
  margin: 16px 0 10px 16px;
  `;

const HiddenDivInfo = styled.div`
  display: flex;
  padding: 0 16px;
  font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
  `;

const HiddenDivText = styled.div`
  line-height: normal;
  font-size: 14px;
  opacity: 0.9;
  `;

const HiddenDivShowTimes = styled.div`
  width:100px;
  text-align:start;
  `;

const HiddenDivNumber = styled.div`
  text-align: start;
  line-height: normal;
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 3px;
  margin-top: 4px;
  `;

const HiddenDivRank = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  
  padding-left: 5px;
  border-left: 1px dashed white;
  `;

const Top1to3 = styled.div`
  background-image: url("${process.env.PUBLIC_URL}/images/04-yellow-frag.png");
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  line-height: 0;
  color: white;
  width: 22px;
  height: 26px;
  font-size: 18px;
  margin: 0 1px;
`;

const Top3to10 = styled.div`
  background-color: #c6c8c5;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 0;
  width: 24px;
  height: 24px;
  font-size: 15px;
`;

const Rank = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  padding-bottom:8px;
`;

const RankContainer = styled.div` 
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      padding-right:5%;
        `;
    }
    else {
      return css`
      padding-right:40px;
        `;
    }
  }}
`;

const Container = styled.div`
  display: flex;
`;

const ChartContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top:70px;
  padding-bottom:20px;
`;
const Part4BackGround = styled.div`
  width: 100%;
  border-radius: 30px;
  background: #cae7e2;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      padding:5%;
        `;
    }
    else {
      return css`
      height: 770px;
        `;
    }
  }}
`;

const YearSelecterContainer = styled.select`
  margin: 0 5% 16px 5%;
  width: 90%;
  height: 48px;
  border-radius: 10px;
  border: none;
  font-size: 18px;
  font-weight: bold;
  padding-left: 32px;
  background: url("${process.env.PUBLIC_URL}/images/arrow.png") no-repeat scroll right center white;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  :focus-visible {
    outline: 2px dashed #cae7e2;
    border-radius: 10px;
  }
`;

const YearSelecterText = styled.p`
  color: #106b64;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
`;

//endregion

function Part4(props: any) {
  const isMobile: any = useSelector((state: RootState) => state.storeSlice.isMobile);
  const isTablet: any = useSelector((state: RootState) => state.storeSlice.isTablet);
  const dispatch = useDispatch();
  const MIN = globalValues.minYear;
  const MAX = globalValues.maxYear;

  const YearSelecter = () => {
    const [value, setValue] = useState(MAX);
    const firstUpdate = useRef(true);

    useMemo(() => {
      if (firstUpdate.current) {
        firstUpdate.current = false;
        return;
      }

      dispatch(getTop10NameWordsByYearInfo({ year: value }));
    }, [value])

    const Options = () => {
      let Result = [];
      for (let i = MAX; i >= MIN; i--) {
        Result.push(
          <option key={i} value={i}>{i}</option>
        );
      }
      return (
        <>
          {Result}
        </>
      );
    }

    return (
      <>
        <YearSelecterText>請選擇年份</YearSelecterText>
        <YearSelecterContainer value={value} onChange={e => setValue(parseInt(e.target.value))}>
          <Options />
        </YearSelecterContainer>
      </>

    )

  }

  const YearSilder = () => {
    const StepPerMove = 945 / (MAX - MIN);

    const [move, setMove] = useState(0);
    const [value, setValue] = useState(MAX);
    const [yearNeedtoGet, setYearNeedtoGet] = useState(MAX);
    const firstUpdate = useRef(true);

    useEffect(() => {
      changePosition();
    }, [value]);

    const changePosition = () => {
      setMove(StepPerMove * (MAX - value));
    };

    const changeYear = (event: React.ChangeEvent<HTMLInputElement>) => {
      setValue(parseInt(event.target.value));
    };

    useMemo(() => {
      if (firstUpdate.current) {
        firstUpdate.current = false;
        return;
      }

      dispatch(getTop10NameWordsByYearInfo({ year: value }));
    }, [value])

    const getData = () => {
      setYearNeedtoGet(value)
    }

    return (
      <>
        <div className="sliderYearDiv"><span style={{ right: `${move}px` }} className="SilderYearText">{value}</span></div>
        <div className="sliderContainer">
          <div>
            <input
              type="range"
              className="slider"
              min={MIN}
              max={MAX}
              value={value}
              step="1"
              onInput={changeYear}
              onMouseUp={getData}
              onKeyUp={getData}
            />
          </div>
        </div>
        <div className="sliderYearFromTo">
          <p>{MIN}</p>
          <p>{MAX}</p>
        </div>
      </>
    );
  };


  const Part4DataChart: React.FC<any> = () => {
    const [lastNameArray, setLastNameArray] = useState([]);
    const [valueIntArray, setValueIntArray] = useState([]);
    const Symbol = 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAAA4CAYAAACxDdW4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAATsSURBVHhe7ZpNaBtHFMfnza7ilEJl3xwcGkN9KRSq3HooqXtOob4VSiEm7aHBDcgH22pxQCUmUaxDBK5pDwl1jz2UGnouTUJ7rm+l0BQHYvBNVi8O0Wqn742e3FrS7o72Q5uF/YGY91ZIs/vfN29m5y2ICMx8sf0BSPccu8K2nR/3q8tP2E2NZr0yL4VbEq6c1Aeke+QKuTe1Unug/REZWaTz61tlAbCmlJjmQ/04INRvKNiVcQrWvF2ZlbaoCqUW0C12jw7Qws+O24HG1Oe1/e6hYIxFoqjBO/IN/qR7d4JRKNajpxvX59lPjFZ9tYy9VdH0EqefFggov7Ja22HfFyORZm5s38M7dBXNEMNTHRVsp5RUVLXqlR08tyvsjgbAd8WV2iJ7nkhuPTm3vnUbT+JjNEPmL5hsO4U/2ImV1uZaI7RABP62dadCEeiL74VPV79+23I6j9AMKdD/gb2DjaWL7ERGJ2elfmE3Ei7Au35J3TeSLMf5CZsYBCJUSSf9mJBKGOUTE0BhwvfBUySdqM2TtBk4K7IViX/urOIMpi6wGxmcYN6hyGR3AO9IkqLCVmzQsoGGMLuhUVLSNB8rOHQ9/9NnuKk32IgVq+MGziZB4J0vsRkbSoDnf/rlJJvbWAHlzrEZGozIN9mMDRpybA7gm7iTAO/YeTYzw9hFAhAvs5kZxi4SjpU/2coMfiI53MaKAvkXm5nBT6REnrU6loxtETguPEXCbP8VmzGijg6r135lJzN4ivR043qDLordWMDnmy/ZzBT+iduVn7IVGZzVDrvCZw9fkQ5uLX2PV3ef3Sgc21b7LbYzh38kIQc3lz6JKNRxwW6//iLsfYclUCSChMJEvozmqMuCx1kXiDASiaB8ghc8h88Vu+gGifWYRD3Y+Gwu6wIRI2+o6d1KepJX6pIS4lX8A4u/Qlccozi/Y7ubZJL22nIFUNMKxCye07RSp/fC8LsjPMFDUGIfvzvkw6cortWG/y+3gXAx4EM0X+oeCYRE+7tjW4tJro2ad8uT8vnZMl7JInZpuBEHT/DsdtwzzxpTy43AZU6gSLTlik/udTQjbJ3AXsF+vhD30NMRBYq2hE1LSf208PfV4sqmb9T7ijSzvo1DJ7YNLke48JFeVkSEosdyJh7Eta+EQfBQFZ4teEXVUJFmq3cvcBnIdGiZg8sJvawISXNzpSSFpMpG2OjxouUKd35qtb7H/gkDIiUqUI+QQiUoUI+W24FSfwl8YAmAAv2MTXICEUpd7VZjzNFDDPQOQlICEUXLVrvUF/uaUyLpaq0Qr3W9RAEh1bdsGyHbE9Uk9rb7oT6oL3Y1J8ONhxltiCVSABgGrqkemrxQEWe11hTMTxd7+ekkktrtAk2DYxOIwFnlEt0cdj0JqrAmAea+kz7/G24g3mNrnEC7c+YG20Oh944w4jzLPQnyPvVNhhaJk+hYo6gHCnCZzaFISSvpdJC2q6u6WiSQ7jVq04BK32wOBZ/FEn8JzAuluuV0LRI+ZCU+a/jh97ZJSkNN0+ubcxJMdNt0UCCHvnfQywlpoh+g2U528RiA5/sBtkhdJOGcxVV+TiC5SAbkIhmQi2RALpIBuUgG5CIZkItkQC6SAblIBuQiGZCLZEAukgG5SAbkIhmQi2SArrvNrG81tZcWIH8YVvamsjYIK9WXUZXolP8F8JWbdC/dD40AAAAASUVORK5CYII=';
    let options;
    if (isMobile || isTablet) {
      options = {
      textStyle: {
        fontFamily: 'Arial',
      },
      legend: {
        show: false
      },
      tooltip: {
        trigger: 'axis',
        transitionDuration :0.1,
        backgroundColor: "rgba(255,255,255,0)",
        borderColor :'#FFF',
        borderWidth:0,
        padding: 0,
        borderRadius:0,
        axisPointer: {
          type: 'shadow'
        },
        textStyle: {
          color: "#FFF",
          fontSize: 20
        },
        formatter: function (params: any) {
          const htmlString = ReactDOMServer.renderToStaticMarkup(
              <HiddenDiv>
                  <HiddenDivName>{params[0].axisValue}</HiddenDivName>
                  <HiddenDivInfo>
                      <HiddenDivShowTimes>
                          <HiddenDivText>出現次數</HiddenDivText>
                          <HiddenDivNumber>{params[0].value}</HiddenDivNumber>
                      </HiddenDivShowTimes>
                      <HiddenDivRank>
                          <HiddenDivText>排名</HiddenDivText>
                          <HiddenDivNumber>{params[0].dataIndex + 1}</HiddenDivNumber>
                      </HiddenDivRank>
                  </HiddenDivInfo>
              </HiddenDiv>
          );

          return htmlString
        },
      },
      grid: {
        containLabel: true,
        top: 0,
        bottom: 0,
        left: 0,
        right: -75
      },
      yAxis: [
        {
          type: 'category',
          data: lastNameArray,
          inverse: true,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            margin: 15,
            fontSize: 22,
            fontWeight: 'bold',
            color: 'black'
          }
        }
        ,
        {
          type: 'category',
          data: valueIntArray,
          inverse: true,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            align: 'right',
            margin: 100,
            fontSize: 20,
            color: 'black',
            fontWeight: 'bold',
            formatter: function (value: any) {
              return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '{SmallSize|人}'
            },
            rich: {
              SmallSize: {
                fontWeight: 'bold',
                verticalAlign: 'bottom',
                fontSize: 16
              }
            }
          },
        }
      ],
      xAxis: {
        type: 'value',
        splitLine: { show: false },
        axisLabel: { show: false },
        axisTick: { show: false },
        axisLine: { show: false }
      },
      series: [
        {
          hoverAnimation: false,
          type: 'pictorialBar',
          data: valueIntArray,
          barWidth: '30',
          symbol: Symbol,
          symbolRepeat: true,
          symbolMargin: '3',
          symbolSize: ['90%', '70%'],

        }
      ]
      };
    }
    else{
      options = {
        textStyle: {
          fontFamily: 'Arial',
        },
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          transitionDuration :0.1,
          backgroundColor: "rgba(255,255,255,0)",
          borderColor :'#FFF',
          borderWidth:0,
          padding: 0,
          borderRadius:0,
          axisPointer: {
            type: 'shadow'
          },
          textStyle: {
            color: "#FFF",
            fontSize: 20
          },
          formatter: function (params: any) {
            const htmlString = ReactDOMServer.renderToStaticMarkup(
                <HiddenDiv>
                    <HiddenDivName>{params[0].axisValue}</HiddenDivName>
                    <HiddenDivInfo>
                        <HiddenDivShowTimes>
                            <HiddenDivText>出現次數</HiddenDivText>
                            <HiddenDivNumber>{params[0].value}</HiddenDivNumber>
                        </HiddenDivShowTimes>
                        <HiddenDivRank>
                            <HiddenDivText>排名</HiddenDivText>
                            <HiddenDivNumber>{params[0].dataIndex + 1}</HiddenDivNumber>
                        </HiddenDivRank>
                    </HiddenDivInfo>
                </HiddenDiv>
            );

            return htmlString
          },
        },
        grid: {
          containLabel: true,
          top: 0,
          bottom: 0,
          left: 0,
          right: -100
        },
        yAxis: [
          {
            type: 'category',
            data: lastNameArray,
            inverse: true,
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: {
              margin: 40,
              fontSize: 28,
              fontWeight: 'bold',
              color: 'black'
            }
          }
          ,
          {
            type: 'category',
            data: valueIntArray,
            inverse: true,
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: {
              align: 'right',
              margin: 180,
              fontSize: 28,
              color: 'black',
              fontWeight: 'bold',
              formatter: function (value: any) {
                return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '{SmallSize|人}'
              },
              rich: {
                SmallSize: {
                  fontWeight: 'bold',
                  verticalAlign: 'bottom',
                  fontSize: 18
                }
              }
            },
          }
        ],
        xAxis: {
          type: 'value',
          splitLine: { show: false },
          axisLabel: { show: false },
          axisTick: { show: false },
          axisLine: { show: false }
        },
        series: [
          {
            hoverAnimation: false,
            type: 'pictorialBar',
            data: valueIntArray,
            barWidth: '40',
            symbol: Symbol,
            symbolRepeat: true,
            symbolMargin: '6%',
            symbolSize: ['90%', '70%'],
            symbolOffset: [0, '-8%']
          }
        ]
        };
    }
    const top10NameWordsByYearInfo: any = useSelector((state: RootState) => state.storeSlice.top10NameWordsByYearInfo);

    useEffect(() => {
      if (top10NameWordsByYearInfo) {
        setLastNameArray(top10NameWordsByYearInfo.top10NameWordsByYear.map((m: any) => m.name));
        setValueIntArray(top10NameWordsByYearInfo.top10NameWordsByYear.map((m: any) => m.count));
      }
    }, [top10NameWordsByYearInfo]);

    if (isMobile || isTablet) {
      return (
        <Container>
          <RankContainer>
            <Rank><Top1to3>1</Top1to3></Rank>
            <Rank><Top1to3>2</Top1to3></Rank>
            <Rank><Top1to3>3</Top1to3></Rank>
            <Rank><Top3to10>4</Top3to10></Rank>
            <Rank><Top3to10>5</Top3to10></Rank>
            <Rank><Top3to10>6</Top3to10></Rank>
            <Rank><Top3to10>7</Top3to10></Rank>
            <Rank><Top3to10>8</Top3to10></Rank>
            <Rank><Top3to10>9</Top3to10></Rank>
            <Rank><Top3to10>10</Top3to10></Rank>
          </RankContainer>
          <ReactECharts option={options} style={{ width: '100%', height: '480px' }} />
        </Container>
      )
    }
    else{
      return (
        <Container>
          <RankContainer>
            <Rank><Top1to3>1</Top1to3></Rank>
            <Rank><Top1to3>2</Top1to3></Rank>
            <Rank><Top1to3>3</Top1to3></Rank>
            <Rank><Top3to10>4</Top3to10></Rank>
            <Rank><Top3to10>5</Top3to10></Rank>
            <Rank><Top3to10>6</Top3to10></Rank>
            <Rank><Top3to10>7</Top3to10></Rank>
            <Rank><Top3to10>8</Top3to10></Rank>
            <Rank><Top3to10>9</Top3to10></Rank>
            <Rank><Top3to10>10</Top3to10></Rank>
          </RankContainer>
          <ReactECharts option={options} style={{ width: '900px', height: '480px' }} />
        </Container>
      )
    }
  }

  useEffect(() => {
  }, []);
  //

  if (isMobile || isTablet) {
    return (
      <>
        <Subtitle>全澳最常用名字單字</Subtitle>
        <Part4BackGround>
          <YearSelecter/>
          <Part4DataChart />
        </Part4BackGround>
      </>

    );
  }
  else{
    return (
      <>
        <Subtitle>全澳最常用名字單字</Subtitle>
        <Part4BackGround>
          <ChartContainer>
            <Part4DataChart />
          </ChartContainer>
          <YearSilder />
        </Part4BackGround>
      </>
    );
  }
}

export default Part4;
